import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const LIST_MAX_HEIGHT = 235;
const LIST_ROW_GAP = 4;

export const Container = styled(FlexColumn)`
    max-height: ${LIST_MAX_HEIGHT}px;
    row-gap: ${LIST_ROW_GAP}px;
    overflow: auto;
`;
